import { connect } from 'react-redux'
import { get, compact } from 'lodash'
import { reduxForm } from 'redux-form'
import SendSmsMessageForm from './SendSmsMessageForm'
import showNumbersNewServiceModal from 'features/Numbers/NumbersNewServiceModal'
import { mobileServices } from 'features/Numbers/Numbers.utils'

const stateToProps = ({ form, numbers }, otherProps) => ({
  formData: get(form, `${otherProps.form}.values`, {}),
  initialValues: {
    to: '--contact.phoneNumber--',
    ...otherProps.initialValues,
  },
  numberOptions: mobileServices(numbers).map(number => ({
    name: compact([number.number, number.customerReference]).join(' - '),
    value: number.id,
  })),
})

const dispatchToProps = {
  showNumbersNewServiceModal,
}

export default connect(
  stateToProps,
  dispatchToProps
)(
  reduxForm({
    destroyOnUnmount: true,
  })(SendSmsMessageForm)
)



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/SendSmsMessage/SendSmsMessageForm.container.js